import { render, staticRenderFns } from "./item-title.vue?vue&type=template&id=6c44ceba&scoped=true&"
import script from "./item-title.vue?vue&type=script&lang=ts&"
export * from "./item-title.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c44ceba",
  null
  
)

export default component.exports